// Tagalog (Filipino) translations
export const tl: Record<string, string> = {
  // ==================== COMMON ====================
  'common.loading': 'Naglo-load...',
  'common.error': 'May naganap na error',
  'common.retry': 'Subukan muli',
  'common.cancel': 'Kanselahin',
  'common.save': 'I-save',
  'common.continue': 'Magpatuloy',
  'common.back': 'Bumalik',
  'common.next': 'Susunod',
  'common.skip': 'Laktawan',
  'common.done': 'Tapos na',
  'common.yes': 'Oo',
  'common.no': 'Hindi',
  'common.ok': 'OK',
  'common.check': 'Suriin',
  'common.correct': 'Tama!',
  'common.incorrect': 'Mali',
  'common.tryAgain': 'Subukan muli',
  'common.start': 'Simulan',
  'common.finish': 'Tapusin',
  'common.submit': 'Isumite',

  // ==================== NAVIGATION ====================
  'nav.home': 'Home',
  'nav.courses': 'Mga Kurso',
  'nav.vocabulary': 'Bokabularyo',
  'nav.profile': 'Profile',
  'nav.settings': 'Settings',
  'nav.logout': 'Mag-log out',
  'nav.leaderboard': 'Ranggo',
  'nav.aiTutor': 'AI Tutor',

  // ==================== ONBOARDING ====================
  'onboarding.welcome': 'Maligayang pagdating sa KoreanFlow!',
  'onboarding.selectLanguage': 'Piliin ang iyong wika',
  'onboarding.selectLanguageDesc': 'Piliin ang wika para sa interface ng app',
  'onboarding.selectGoal': 'Ano ang iyong layunin sa pag-aaral?',
  'onboarding.selectGoalDesc': 'Ipa-personalize namin ang iyong landas sa pag-aaral',
  'onboarding.takeTest': 'Kumuha ng Level Test',
  'onboarding.takeTestDesc': 'Alamin ang iyong level sa Korean sa loob ng 5 minuto',
  'onboarding.skipTest': 'Laktawan muna',
  'onboarding.skipTestDesc': 'Magsimula sa simula',
  'onboarding.letsGo': 'Tara na!',
  'onboarding.step': 'Hakbang',
  'onboarding.of': 'ng',

  // ==================== LEVEL TEST ====================
  'levelTest.title': 'Level Test',
  'levelTest.subtitle': 'Hanapin natin ang iyong level sa Korean',
  'levelTest.duration': 'Mga 5 minuto',
  'levelTest.questions': 'mga tanong',
  'levelTest.vocabulary': 'Bokabularyo',
  'levelTest.grammar': 'Grammar',
  'levelTest.listening': 'Pakikinig',
  'levelTest.speaking': 'Pagsasalita',
  'levelTest.analyzing': 'Sinusuri ang iyong mga resulta...',
  'levelTest.yourLevel': 'Ang Iyong Level',
  'levelTest.congratulations': 'Binabati kita!',
  'levelTest.resultDesc': 'Batay sa iyong mga resulta ng pagsusulit',
  'levelTest.startLearning': 'Simulan ang Pag-aaral',
  'levelTest.retakeTest': 'Ulitin ang Pagsusulit',
  'levelTest.sectionComplete': 'Tapos na ang Seksyon',
  'levelTest.nextSection': 'Susunod na Seksyon',
  'levelTest.listenAndAnswer': 'Makinig at sumagot',
  'levelTest.speakNow': 'Magsalita ngayon',
  'levelTest.tapToListen': 'Pindutin para makinig',

  // ==================== CEFR LEVELS ====================
  'cefr.A1': 'Baguhan',
  'cefr.A2': 'Elementarya',
  'cefr.B1': 'Intermediate',
  'cefr.B2': 'Upper Intermediate',
  'cefr.C1': 'Advanced',
  'cefr.C2': 'Eksperto',
  'cefr.A1.desc': 'Mga pangunahing pagbati at simpleng ekspresyon',
  'cefr.A2.desc': 'Mga simpleng usapan tungkol sa pang-araw-araw na buhay',
  'cefr.B1.desc': 'Kayang harapin ang karamihan ng sitwasyon sa pagbiyahe',
  'cefr.B2.desc': 'Makakausap ng maayos ang mga native speaker',
  'cefr.C1.desc': 'Kayang magpahayag ng mga ideya nang maayos at spontaneous',
  'cefr.C2.desc': 'Halos katulad ng native speaker sa lahat ng sitwasyon',

  // ==================== LEAGUE / RANKING ====================
  'league.title': 'Liga',
  'league.weeklyRanking': 'Lingguhang Ranggo',
  'league.bronze': 'Bronze',
  'league.silver': 'Silver',
  'league.gold': 'Gold',
  'league.platinum': 'Platinum',
  'league.diamond': 'Diamond',
  'league.promotion': 'Promotion Zone',
  'league.demotion': 'Demotion Zone',
  'league.safe': 'Safe Zone',
  'league.weeklyXP': 'Lingguhang XP',
  'league.rank': 'Ranggo',
  'league.daysLeft': 'araw na natitira',
  'league.promoted': 'Na-promote!',
  'league.demoted': 'Na-demote',
  'league.stayed': 'Nanatili',
  'league.noData': 'Wala pang ranking data',
  'league.earnXP': 'Kumita ng XP para sumali sa liga!',
  'league.topPercent': 'Top {percent}%',

  // ==================== LANDING PAGE ====================
  'landing.tagline': '#1 Korean Learning App',
  'landing.title': 'Matuto ng Korean',
  'landing.titleAccent': 'sa Masayang Paraan',
  'landing.subtitle': 'Master ang Korean sa pamamagitan ng maikling mga aralin, tradisyonal na kulturang content, at AI-powered na pronunciation feedback. Sumali sa 1M+ na nag-aaral!',
  'landing.getStarted': 'Magsimula ng Libre',
  'landing.learnMore': 'Alamin Pa',
  'landing.login': 'Mag-log In',
  'landing.startFree': 'Simulang Libre',
  'landing.learners': 'Mga Nag-aaral',
  'landing.lessons': 'Mga Aralin',
  'landing.countries': 'Mga Bansa',

  // ==================== FEATURES ====================
  'features.title': 'Bakit KoreanFlow?',
  'features.subtitle': 'Ang aming natatanging diskarte ay pinagsasama ang gamification, authentic na content, at AI technology para gawing masaya at epektibo ang pag-aaral ng Korean.',
  'features.streaks.title': 'Daily Streaks',
  'features.streaks.desc': 'Bumuo ng habit sa pamamagitan ng daily goals at streak rewards. Manatiling motivated sa XP at gems.',
  'features.folksong.title': 'Folk Songs',
  'features.folksong.desc': 'Matuto ng Korean sa pamamagitan ng tradisyonal na folk songs. Unawain ang lyrics at kultura!',
  'features.culture.title': 'Korean Culture',
  'features.culture.desc': 'Galugarin ang mga kasabihan, slang, at mahahalagang phrases. Master ang authentic na expressions.',
  'features.ai.title': 'AI Chatbot',
  'features.ai.desc': 'Mag-practice ng mga usapan sa aming AI tutor. Makakuha ng instant feedback at corrections.',
  'features.leaderboard.title': 'Leaderboards',
  'features.leaderboard.desc': 'Makipagkumpetensya sa mga kaibigan at mga nag-aaral sa buong mundo. Umakyat sa weekly rankings!',
  'features.srs.title': 'SRS Vocabulary',
  'features.srs.desc': 'Ang smart repetition system ay tinitiyak na matatandaan mo ang natutunan mo. Habang buhay.',
  'features.pronunciation.title': 'Pronunciation Feedback',
  'features.pronunciation.desc': 'AI-powered pronunciation analysis na may detalyadong scoring.',

  // ==================== CTA ====================
  'cta.title': 'Handa ka na bang Simulan ang Iyong Paglalakbay?',
  'cta.subtitle': 'Sumali sa milyun-milyong nag-aaral at magsimulang magsalita ng Korean ngayon. Libre ito!',
  'cta.button': 'Magsimulang Matuto ng Libre',

  // ==================== AUTH ====================
  'auth.login': 'Mag-log In',
  'auth.register': 'Mag-sign Up',
  'auth.email': 'Email',
  'auth.emailPlaceholder': 'Ilagay ang iyong email',
  'auth.password': 'Password',
  'auth.passwordPlaceholder': 'Gumawa ng password',
  'auth.confirmPassword': 'Kumpirmahin ang Password',
  'auth.forgotPassword': 'Nakalimutan ang password?',
  'auth.noAccount': 'Wala pang account?',
  'auth.haveAccount': 'May account na?',
  'auth.orContinueWith': 'o magpatuloy sa',
  'auth.google': 'Google',
  'auth.apple': 'Apple',
  'auth.createAccount': 'Gumawa ng Account',
  'auth.createAccountTitle': 'Gumawa ng Iyong Account',
  'auth.createAccountSubtitle': 'Simulan ang iyong Korean learning journey ngayon',
  'auth.username': 'Username',
  'auth.usernamePlaceholder': 'Pumili ng username',
  'auth.usernameHint': 'Mga letra, numero, at underscore lang',
  'auth.passwordHint': 'Hindi bababa sa 8 character na may uppercase, lowercase, at numero',
  'auth.nativeLanguage': 'Native Language',
  'auth.nativeLanguageHint': 'Ipapakita namin ang mga paliwanag sa wikang ito',
  'auth.termsAgree': 'Sa pag-sign up, sumasang-ayon ka sa aming',
  'auth.terms': 'Terms',
  'auth.and': 'at',
  'auth.privacyPolicy': 'Privacy Policy',
  'auth.loginTitle': 'Maligayang Pagbabalik',
  'auth.loginSubtitle': 'Mag-sign in para magpatuloy sa pag-aaral',
  'auth.loginButton': 'Mag-log In',
  'auth.registerButton': 'Mag-sign Up',
  'auth.rememberMe': 'Tandaan ako',

  // ==================== DASHBOARD ====================
  'dashboard.welcome': 'Maligayang pagbabalik',
  'dashboard.todayGoal': 'Goal Ngayon',
  'dashboard.streak': 'Streak',
  'dashboard.days': 'araw',
  'dashboard.xp': 'XP',
  'dashboard.level': 'Level',
  'dashboard.continueLearning': 'Magpatuloy sa Pag-aaral',
  'dashboard.recommended': 'Inirerekomenda para sa iyo',
  'dashboard.myCourses': 'Mga Kurso Ko',
  'dashboard.seeAll': 'Tingnan Lahat',
  'dashboard.dailyGoalComplete': 'Natapos ang daily goal!',
  'dashboard.keepGoing': 'Magpatuloy!',
  'dashboard.yourLevel': 'Ang Iyong Level',
  'dashboard.weeklyProgress': 'Lingguhang Progress',

  // ==================== COURSES ====================
  'courses.title': 'Lahat ng Kurso',
  'courses.search': 'Maghanap ng mga kurso...',
  'courses.all': 'Lahat',
  'courses.beginner': 'Baguhan',
  'courses.elementary': 'Elementarya',
  'courses.intermediate': 'Intermediate',
  'courses.advanced': 'Advanced',
  'courses.lessons': 'aralin',
  'courses.enrolled': 'naka-enroll',
  'courses.progress': 'Progress',
  'courses.completed': 'natapos',
  'courses.recommended': 'Inirerekomenda',
  'courses.forYourLevel': 'Para sa iyong level',
  'courses.locked': 'Naka-lock',
  'courses.unlockWith': 'I-unlock gamit ang Premium',

  // ==================== LESSON ====================
  'lesson.loading': 'Naglo-load ang aralin...',
  'lesson.notFound': 'Hindi natagpuan ang aralin',
  'lesson.quit': 'Sigurado ka bang gusto mong umalis? Mawawala ang iyong progress.',
  'lesson.complete': 'Tapos na ang Aralin!',
  'lesson.perfect': 'Perpekto!',
  'lesson.amazing': 'Kahanga-hanga! Tama lahat ng sagot mo!',
  'lesson.xpEarned': 'Nakuhang XP',
  'lesson.accuracy': 'Accuracy',
  'lesson.correct': 'Tama',
  'lesson.goBack': 'Bumalik',
  'lesson.skip': 'Laktawan',
  'lesson.unknownType': 'Hindi kilalang uri ng exercise',

  // ==================== EXERCISES ====================
  'exercise.tapToReveal': 'Pindutin para ipakita ang sagot',
  'exercise.matchPairs': 'Ipares ang mga ito',
  'exercise.matched': 'naipares',
  'exercise.arrangeWords': 'Ayusin ang mga salita',
  'exercise.speak': 'Magsalita',
  'exercise.listening': 'Nakikinig... Magsalita ngayon!',
  'exercise.processing': 'Pinoproseso ang iyong pagsasalita...',
  'exercise.tapToSpeak': 'Pindutin para magsalita',
  'exercise.cantSpeak': 'Hindi makapagsalita ngayon? Laktawan',
  'exercise.again': 'Ulit',
  'exercise.gotIt': 'Nakuha ko na!',

  // ==================== PRONUNCIATION ====================
  'pronunciation.title': 'Pronunciation Practice',
  'pronunciation.subtitle': 'Pagbutihin ang iyong Korean pronunciation sa pamamagitan ng AI feedback',
  'pronunciation.selectLevel': 'Piliin ang Iyong Level',
  'pronunciation.beginner': 'Baguhan',
  'pronunciation.intermediate': 'Intermediate',
  'pronunciation.advanced': 'Advanced',
  'pronunciation.score': 'Ang Iyong Score',
  'pronunciation.accuracy': 'Accuracy',
  'pronunciation.fluency': 'Fluency',
  'pronunciation.intonation': 'Intonation',
  'pronunciation.feedback': 'Feedback',
  'pronunciation.tryAgain': 'Subukan Muli',
  'pronunciation.next': 'Susunod',
  'pronunciation.listen': 'Makinig',
  'pronunciation.slow': 'Mabagal',
  'pronunciation.sessionComplete': 'Tapos na ang Session!',
  'pronunciation.bestScore': 'Pinakamataas na Score',
  'pronunciation.average': 'Average',
  'pronunciation.attempts': 'Mga Pagsubok',
  'pronunciation.practiceAgain': 'Mag-practice Muli',
  'pronunciation.changeLevel': 'Palitan ang Level',
  'pronunciation.tips': 'Mga Tips para sa Mas Mahusay na Pronunciation',
  'pronunciation.tip1': 'Makinig muna sa audio',
  'pronunciation.tip2': 'Magsalita ng malinaw at sa steady na bilis',
  'pronunciation.tip3': 'Gamitin ang slow playback para sa mahihirap na salita',
  'pronunciation.tip4': 'Mag-practice sa tahimik na lugar',

  // ==================== VOCABULARY ====================
  'vocab.title': 'Bokabularyo',
  'vocab.totalWords': 'Kabuuang Salita',
  'vocab.mastered': 'Na-master',
  'vocab.dueToday': 'Due Ngayon',
  'vocab.reviewSession': 'Review Session',
  'vocab.wordsDue': 'mga salitang kailangang i-review',
  'vocab.startReview': 'Simulan ang Review',
  'vocab.allCaughtUp': 'Updated na lahat!',
  'vocab.noWordsDue': 'Walang salitang kailangang i-review',
  'vocab.sessionComplete': 'Tapos na ang Session!',
  'vocab.allWords': 'Lahat ng Salita',

  // ==================== PROFILE ====================
  'profile.title': 'Profile',
  'profile.level': 'Level',
  'profile.xpToNext': 'XP papunta sa susunod na level',
  'profile.totalXp': 'Kabuuang XP',
  'profile.currentStreak': 'Kasalukuyang Streak',
  'profile.lessonsDone': 'Mga Aralin na Natapos',
  'profile.timeLearned': 'Oras na Natuto',
  'profile.achievements': 'Mga Achievement',
  'profile.settings': 'Settings',
  'profile.dailyGoals': 'Daily Goals',
  'profile.allAchievements': 'Lahat ng Achievement',
  'profile.logOut': 'Mag-log Out',
  'profile.koreanLevel': 'Korean Level',

  // ==================== SETTINGS ====================
  'settings.title': 'Settings',
  'settings.language': 'Wika ng App',
  'settings.preferences': 'Preferences',
  'settings.sound': 'Sound Effects',
  'settings.soundEffects': 'Sound Effects',
  'settings.soundEffectsDesc': 'Mag-play ng sounds kapag sumasagot ng exercises',
  'settings.notifications': 'Notifications',
  'settings.notificationsDesc': 'Tumanggap ng daily learning reminders',
  'settings.darkMode': 'Dark Mode',
  'settings.darkModeDesc': 'Dark theme para sa mas komportableng pagtingin',
  'settings.dailyReminder': 'Daily Reminder',
  'settings.account': 'Account',
  'settings.editProfile': 'I-edit ang Profile',
  'settings.terms': 'Terms of Service',
  'settings.privacy': 'Privacy Policy',
  'settings.help': 'Tulong',
  'settings.about': 'Tungkol',
  'settings.retakeTest': 'Ulitin ang Level Test',
  'settings.retakeTestDesc': 'Suriin ang iyong kasalukuyang Korean level',

  // ==================== FOOTER ====================
  'footer.privacy': 'Privacy',
  'footer.terms': 'Terms',
  'footer.contact': 'Contact',
  'footer.rights': 'Lahat ng karapatan ay nakareserba.',

  // ==================== COOKIE CONSENT ====================
  'cookie.title': 'Gumagamit kami ng cookies',
  'cookie.description': 'Gumagamit kami ng cookies para mapabuti ang iyong karanasan, suriin ang site traffic, at i-personalize ang content. Maaari mong piliin na tanggapin o tanggihan ang non-essential cookies.',
  'cookie.learnMore': 'Alamin pa',
  'cookie.acceptAll': 'Tanggapin Lahat',
  'cookie.rejectAll': 'Tanggihan Lahat',

  // ==================== QUICK ACTIONS ====================
  'quickAction.vocabulary': 'Bokabularyo',
  'quickAction.reviewWords': 'I-review ang mga salita',
  'quickAction.allCourses': 'Lahat ng Kurso',
  'quickAction.browseLessons': 'Mag-browse ng mga aralin',

  // ==================== COURSE DETAIL ====================
  'courseDetail.notFound': 'Hindi natagpuan ang kurso',
  'courseDetail.lessons': 'mga aralin',
  'courseDetail.completed': 'natapos',

  // ==================== BOTTOM NAVIGATION ====================
  'bottomNav.home': 'Home',
  'bottomNav.courses': 'Kurso',
  'bottomNav.vocab': 'Vocab',
  'bottomNav.profile': 'Profile',

  // ==================== AI TUTOR ====================
  'aiTutor.title': 'AI Tutor',
  'aiTutor.selectScenario': 'Pumili ng senaryo',
  'aiTutor.freeTalk': 'Free Talk',
  'aiTutor.cafe': 'Cafe Order',
  'aiTutor.shopping': 'Shopping',
  'aiTutor.restaurant': 'Restaurant',
  'aiTutor.friends': 'Makipagkaibigan',
  'aiTutor.interview': 'Job Interview',
  'aiTutor.typeMessage': 'Mag-type ng mensahe...',
  'aiTutor.send': 'Ipadala',

  // ==================== ERRORS ====================
  'error.generic': 'May nangyaring mali',
  'error.network': 'Network error. Pakisuri ang iyong connection.',
  'error.notFound': 'Hindi natagpuan ang page',
  'error.unauthorized': 'Mangyaring mag-log in para magpatuloy',
  'error.microphoneAccess': 'Tinanggihan ang access sa mikropono',
  'error.speechNotSupported': 'Hindi suportado ang speech recognition. Subukan ang Chrome browser.',
  // ==================== ADDED (i18n audit 2026-10-24) ====================
  'nav.learn': 'Mag-aral',
  'nav.culture': 'Kultura',
  'nav.chat': 'Chat',
  'nav.ranking': 'Ranking',
  'nav.family': 'Pamilya',
  'nav.premium': 'Premium',
  'home.greeting': 'Kumusta',
  'home.streak': 'araw na streak',
  'home.dailyGoal': 'Pang-araw-araw na Goal',
  'home.myLanguages': 'Mga Wika Ko',
  'home.addLanguage': 'Magdagdag ng Wika',
  'home.recommended': 'Inirerekomenda',
  'home.continue': 'Ituloy ang Pag-aaral',
  'home.selectLanguage': 'Pumili ng wika',
  'home.totalXp': 'Kabuuang XP',
  'home.bestStreak': 'Pinakamahabang Streak',
  'home.level': 'Level',
  'chat.aiTutor': 'AI Tutor',
  'chat.aiTutorDesc': 'Mag-practice ng usapan kasama ang AI',
  'onboarding.welcome.subtitle': 'Mag-aral ng kahit anong wika gamit ang AI-powered na usapan',
  'onboarding.selectUILanguage': 'Piliin ang iyong wika',
  'onboarding.selectUILanguage.subtitle': 'Ito ang gagamitin para sa interface ng app',
  'onboarding.selectLearningLanguage': 'Ano ang gusto mong matutunan?',
  'onboarding.selectLearningLanguage.subtitle': 'Pwede kang mag-aral ng maraming wika',
  'onboarding.selectDailyGoal': 'Itakda ang pang-araw-araw na goal',
  'onboarding.selectDailyGoal.subtitle': 'Gaano katagal kaya mo bawat araw?',
  'onboarding.ready': 'Handa ka na!',
  'onboarding.ready.subtitle': 'Simulan na natin ang iyong paglalakbay sa pag-aaral ng wika',
  'onboarding.features.languages': '4 na Wika',
  'onboarding.features.aiTutor': 'AI Tutor',
  'onboarding.features.dailyGoals': 'Pang-araw-araw na Goal',
  'dailyGoal.5min': '5 minuto',
  'dailyGoal.10min': '10 minuto',
  'dailyGoal.15min': '15 minuto',
  'dailyGoal.20min': '20 minuto',
  'dailyGoal.casual': 'Casual na pace',
  'dailyGoal.regular': 'Regular na practice',
  'dailyGoal.serious': 'Seryosong mag-aaral',
  'dailyGoal.intense': 'Intensive na training',
  'learn.title': 'Mag-aral',
  'learn.currentLevel': 'Kasalukuyang Level',
  'learn.noCoursesYet': 'Malapit na!',
  'learn.noCoursesDescription': 'Inihahanda pa ang mga course para sa wikang ito.',
  'learn.lessonsCompleted': 'aralin na tapos',
  'learn.startCourse': 'Simulan ang Course',
  'learn.continueCourse': 'Ituloy',
  'learn.courseCompleted': 'Tapos na',
  'learn.locked': 'Naka-lock',
  'learn.unlockBy': 'Tapusin ang nakaraang course para ma-unlock',
  'course.progress': 'Progreso',
  'course.lessons': 'Mga Aralin',
  'course.lessonsCompleted': 'aralin na tapos',
  'course.noLessons': 'Inihahanda pa ang mga aralin...',
  'lesson.tapToReveal': 'I-tap para makita ang kahulugan',
  'lesson.examples': 'Mga Halimbawa',
  'lesson.questionsCorrect': 'tama',
  'lesson.wordsLearned': 'Mga Salita',
  'lesson.grammarPoints': 'Grammar',
  'lesson.backToCourse': 'Bumalik sa Course',
  'lesson.practiceAgain': 'Mag-practice Ulit',
  'lesson.whatYouLearn': 'Ang matututunan mo',
  'lesson.newWords': 'bagong salita',
  'lesson.exercises': 'mga exercise',
  'lesson.startLesson': 'Simulan ang Aralin',
  'lesson.reviewLesson': 'I-review ang Aralin',
  'lesson.learnVocabulary': 'Matuto ng Bokabularyo',
  'lesson.grammarPoint': 'Grammar Point',
  'lesson.practice': 'Practice',
  'profile.guest': 'Guest',
  'profile.days': 'araw',
  'profile.longestStreak': 'Pinakamahaba',
  'profile.lessonsCompleted': 'tapos',
  'profile.dailyGoal': 'Pang-araw-araw na Goal',
  'profile.learningLanguages': 'Mga Pinag-aaralang Wika',
  'profile.noLanguages': 'Walang napiling wika',
  'profile.minutesPerDay': 'min/araw',
  'profile.learningHistory': 'Kasaysayan ng Pag-aaral',
  'profile.viewProgress': 'Tingnan ang iyong progreso',
  'profile.appSettings': 'Mga Setting ng App',
  'profile.languageNotifications': 'Wika, notifications',
  'profile.loginToSave': 'Mag-log in para ma-save ang iyong progreso',
  'settings.learning': 'Pag-aaral',
  'settings.dailyGoal': 'Pang-araw-araw na Goal',
  'settings.minutesPerDay': 'minuto bawat araw',
  'settings.selectLanguage': 'Pumili ng Wika',
  'settings.selectDailyGoal': 'Itakda ang Pang-araw-araw na Goal',
  'settings.perDay': 'bawat araw',
  'settings.appInfo': 'Impormasyon ng App',
  'settings.logout': 'Mag-log Out',
};

export default tl;
